import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="doc" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#3769a3"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#1d436f"
          />
        </g>
        <path
          id="Контур_815"
          data-name="Контур 815"
          d="M-5.717-.381v-3.89h1.253a1.843,1.843,0,0,1,.927.234,1.643,1.643,0,0,1,.643.66,1.993,1.993,0,0,1,.234.955v.179a2,2,0,0,1-.226.958,1.651,1.651,0,0,1-.636.663,1.8,1.8,0,0,1-.915.242Zm.938-3.166V-1.1h.326a.73.73,0,0,0,.62-.287,1.408,1.408,0,0,0,.216-.854v-.168a1.4,1.4,0,0,0-.216-.85.742.742,0,0,0-.631-.286Zm5.949,1.3A2.294,2.294,0,0,1,.959-1.238a1.56,1.56,0,0,1-.6.675,1.67,1.67,0,0,1-.886.236,1.694,1.694,0,0,1-.882-.228,1.557,1.557,0,0,1-.6-.653,2.228,2.228,0,0,1-.226-.975V-2.4a2.3,2.3,0,0,1,.21-1.009,1.556,1.556,0,0,1,.6-.675,1.682,1.682,0,0,1,.891-.238,1.666,1.666,0,0,1,.882.235,1.584,1.584,0,0,1,.6.669,2.238,2.238,0,0,1,.218,1ZM.216-2.409a1.636,1.636,0,0,0-.194-.88.621.621,0,0,0-.554-.3q-.705,0-.745,1.058l0,.286a1.683,1.683,0,0,0,.19.879.62.62,0,0,0,.564.307.613.613,0,0,0,.548-.3,1.637,1.637,0,0,0,.2-.868Zm4.64.711a1.421,1.421,0,0,1-.219.717A1.322,1.322,0,0,1,4.074-.5a1.914,1.914,0,0,1-.827.171,1.528,1.528,0,0,1-1.208-.5A2.063,2.063,0,0,1,1.6-2.238V-2.43a2.355,2.355,0,0,1,.2-1,1.508,1.508,0,0,1,.573-.663,1.6,1.6,0,0,1,.866-.234,1.677,1.677,0,0,1,1.138.373,1.473,1.473,0,0,1,.489,1.027H3.929a.7.7,0,0,0-.179-.51.736.736,0,0,0-.513-.155.56.56,0,0,0-.513.262,1.683,1.683,0,0,0-.171.836v.275a1.862,1.862,0,0,0,.156.89.572.572,0,0,0,.538.267.72.72,0,0,0,.494-.152A.646.646,0,0,0,3.923-1.7Z"
          transform="translate(575.542 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
